import { type IListUsersHandler, ListUsers, UserItem } from '@telespot/authentication/use-cases';

import { ParseBaseRepository } from '../../parse-base.repository';
import { AffiliateTopology, OrganizationTopology, UserTopology } from '../../repositories';
import { ObjectTopology } from '../../parse.topology';

export class ParseListUsersHandler extends ParseBaseRepository implements IListUsersHandler {
  public async execute(command: ListUsers): Promise<UserItem[]> {
    const { organizationId, limit, nextToken, filters } = command.details;

    const organizationPointer = this.subclasses
      .getSubclass(OrganizationTopology.TABLE)
      .createWithoutData(organizationId);

    const query = new this.parse.Query(AffiliateTopology.TABLE)
      .equalTo(AffiliateTopology.ORGANIZATION, organizationPointer)
      .exists(AffiliateTopology.USER)
      .include(AffiliateTopology.USER)
      .descending(ObjectTopology.CREATED_AT)
      .limit(limit);

    if (!!filters?.username && filters?.username?.trim() !== '') {
      const escapedUsername = this.escapeRegExp(filters.username);
      const userFilterQuery = new this.parse.Query(UserTopology.TABLE).matches(
        UserTopology.USERNAME,
        new RegExp(escapedUsername, 'i')
      );

      query.matchesQuery(AffiliateTopology.USER, userFilterQuery);
    }

    if (nextToken) {
      query.lessThan(ObjectTopology.CREATED_AT, nextToken.affiliationDate);
    }

    const affiliates = await query.find(this.options);

    return affiliates.map((affiliate) => ({
      id: affiliate.get(AffiliateTopology.USER)?.id ?? `deleted_user_${affiliate.id}`,
      affiliationId: affiliate.id,
      username: affiliate.get(AffiliateTopology.USER)?.get(UserTopology.USERNAME) ?? `Deleted User`,
      avatarUrl: affiliate.get(AffiliateTopology.USER)?.get(UserTopology.AVATAR)?.url(),
      emailVerified: affiliate.get(AffiliateTopology.USER)?.get(UserTopology.VERIFIED),
      affiliationDate: affiliate.get(ObjectTopology.CREATED_AT),
    }));
  }
}
